const emailRegExp =
  /* eslint-disable-next-line no-useless-escape */
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const validateUserEmail = (emailString: string): string => {
  if (!emailRegExp.test(emailString)) {
    return "Please provide valid email";
  }

  return null;
};
